var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGraph = function SvgGraph(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 63.366,
    viewBox: "0 0 79 63.366",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_928",
    "data-name": "Grupo 928",
    transform: "translate(-2.5 -11.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_927",
    "data-name": "Grupo 927",
    transform: "translate(2.5 11.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1569",
    "data-name": "Ret\\xE2ngulo 1569",
    width: 9.896,
    height: 13.305,
    transform: "translate(18.877 31.184)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1570",
    "data-name": "Ret\\xE2ngulo 1570",
    width: 9.896,
    height: 23.284,
    transform: "translate(33.429 21.205)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1571",
    "data-name": "Ret\\xE2ngulo 1571",
    width: 9.896,
    height: 33.346,
    transform: "translate(47.899 11.143)",
    fill: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2529",
    "data-name": "Caminho 2529",
    d: "M70.191,52.647l-3.742,3.742L71.355,61.3H16.471V22.045l4.906,4.906,3.742-3.742L13.809,11.9,2.5,23.209l3.742,3.742,4.906-4.906V66.618H71.355l-4.906,4.906,3.742,3.742L81.5,63.957Z",
    transform: "translate(-2.5 -11.9)",
    fill: "#e2e2e2"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGraph, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/graph.38439f01.svg";
export { ForwardRef as ReactComponent };